export const VIEWMODE = {
    EDIT: "EDIT",
    VIEW: "VIEW"
};
